/** Tenant DO → player: screen was removed from the tenant (payload is always null). */
export const PLAYER_WS_TYPE_PLAYER_UNREGISTERED = 'player-unregistered' as const

/** WebSocket close code after {@link PLAYER_WS_TYPE_PLAYER_UNREGISTERED} (fallback for missed push). */
export const TENANT_PLAYER_UNREGISTER_WS_CLOSE_CODE = 3000

export const TENANT_PLAYER_UNREGISTER_WS_CLOSE_REASON = 'player unregistered from tenant' as const

/** WebSocket close reason when the whole tenant is deprovisioned (`TenantDO.destroy`). */
export const TENANT_REMOVED_WS_CLOSE_REASON = 'tenant removed' as const

/** Idle / ping-timeout close on Tenant DO — must not be treated as unregister on the player. */
export const TENANT_PLAYER_IDLE_WS_CLOSE_CODE = 3004
export const TENANT_PLAYER_IDLE_WS_CLOSE_REASON = 'connection idle' as const

/** True when the server closed the player socket because registration was dropped (screen or tenant). */
export function isTenantRegistrationDropWebSocketClose(code: number, reason: string): boolean {
  if (code !== TENANT_PLAYER_UNREGISTER_WS_CLOSE_CODE) {
    return false
  }
  return reason.includes(TENANT_PLAYER_UNREGISTER_WS_CLOSE_REASON)
    || reason.includes(TENANT_REMOVED_WS_CLOSE_REASON)
}
